import { IonCard, IonCardContent, IonCardTitle, IonCol, IonRow } from '@ionic/react';
import { Fragment } from 'react';

import { Button } from '@/components/Button';
import { Icon } from '@/components/Icon';

import { mergeClassNames } from '@/utils/mergeClassNames';

import styles from './Stepper.module.css';

import { IconRotate } from '../Icon/types';
import { StepSpacer } from './StepSpacer';

interface StepperProps {
  steps: {
    name: string;
    title: string;
    description: string;
  }[];
  currentStep: number;
  onStepChange: (step: number) => void;
  isNextDisabled: boolean;
  isPreviousDisabled?: boolean;
}

export const Stepper = ({ steps, currentStep, onStepChange, isNextDisabled, isPreviousDisabled }: StepperProps) => {
  function prevStep() {
    onStepChange(currentStep - 1);
  }

  function nextStep() {
    onStepChange(currentStep + 1);
  }

  return (
    <IonCard className={styles.card}>
      <div className={styles.steps}>
        {steps.map((step, idx) => (
          <Fragment key={step.name}>
            <div
              className={mergeClassNames(
                styles.step,
                currentStep === idx && styles.current,
                (currentStep > idx || (currentStep === idx && !isNextDisabled)) && styles.completed,
              )}>
              <div>{currentStep > idx ? <Icon name='checkmark' size={16} /> : <p>{idx + 1}</p>}</div>
              <p>{step.name}</p>
            </div>
            {idx < steps.length - 1 && <StepSpacer />}
          </Fragment>
        ))}
      </div>

      <div className={styles.content}>
        <Button
          disabled={currentStep === 0 || isPreviousDisabled}
          leadingIcon='chevron'
          leadingIconDirection={IconRotate.West}
          onClick={prevStep}
          size='medium'
          variant='secondary'>
          Previous
        </Button>

        <IonCardContent>
          <IonCardTitle className={styles.title}>{steps[currentStep].title}</IonCardTitle>
          <p className={styles.body}>{steps[currentStep].description}</p>
        </IonCardContent>

        <Button
          disabled={isNextDisabled}
          onClick={nextStep}
          size='medium'
          trailingIcon='chevron'
          trailingIconDirection={IconRotate.East}>
          Continue
        </Button>
      </div>
    </IonCard>
  );
};
